import React, { useEffect, useMemo } from "react";
import CustomBreadCrumb from "../components/lib/CustomBreacCrumb";
import { CommunityIcon, GroupIcon, MoreIcon, Security, TimeIcon, UserIcon } from "../components/lib/icons";
import { useLoginUserCount, useUserCount } from "../components/network/user";
import { Column, Line } from "@ant-design/charts";
import { Card, Col, Row } from "antd";

const Dashboard = () => {
  const [userLoading, fetchUserCount, userData] = useUserCount();
  const [loginuserLoading, loginfetchUserCount, loginuserData] = useLoginUserCount();
  const _token = localStorage.getItem("token");
  useEffect(() => {
    fetchUserCount(_token);
    loginfetchUserCount(_token);
  }, []);
  const lastCount = useMemo(() => {
    let total = 0;
    if (userData?.date_count) {
      for (const key in userData.date_count) {
        total += userData.date_count[key];
      }
    }
    return total;
  }, [userData]);
  const newUserChart = useMemo(() => {
    let result = [];
    if (userData?.date_count) {
      for (const key in userData.date_count) {
        result.push({ date: key, value: userData.date_count[key] });
      }
    }
    return result;
  }, [userData]);
  const loginUserChart = useMemo(() => {
    let result = [];
    if (loginuserData?.Count) {
      for (const key in loginuserData.Count) {
        result.push({ date: key, value: loginuserData.Count[key] });
      }
    }
    return result;
  }, [loginuserData]);
  return (
    <div>
      <CustomBreadCrumb item={[{ name: "Хянах самбар", link: "/dashboard" }]} />
      <div className="grid grid-cols-4 gap-4">
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <div className="flex items-start justify-between">
            <h6 className="text-2xl font-bold text-gray-700">{userData?.total}</h6>
            <div className="flex items-center justify-center shadow bg-whtie rounded-lg h-9 w-9 stroke-primary">
              <UserIcon />
            </div>
          </div>
          <p className="text-md font-light text-gray-700 mt-3">Нийт бүртгүүлсэн хэрэглэгчийн тоо</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <div className="flex items-start justify-between">
            <h6 className="text-2xl font-bold text-gray-700">{loginuserData?.loginCount}</h6>
            <div className="flex items-center justify-center shadow bg-whtie rounded-lg h-9 w-9 stroke-primary">
              <UserIcon />
            </div>
          </div>
          <p className="text-md font-light text-gray-700 mt-3">Идэвхитэй хэрэглэгчийн тоо(Сүүлийн 7 хоног)</p>
        </div>

        <div className="bg-white rounded-xl p-4 shadow-sm">
          <div className="flex items-start justify-between">
            <h6 className="text-2xl font-bold text-gray-700">{lastCount}</h6>
            <div className="flex items-center justify-center shadow bg-whtie rounded-lg h-9 w-9 stroke-primary">
              <TimeIcon />
            </div>
          </div>
          <p className="text-md font-light text-gray-700 mt-3">Шинэ орж ирсэн хэрэглэгч 7 хоног</p>
        </div>
      </div>
      <div style={{height:50}}/>
      <Row gutter={15}>
        <Col span={8}>
          <Card title="Шинэ хэрэглэгчид">
            <Column xField={"date"} yField={"value"} data={newUserChart} />
          </Card>
        </Col>
        <Col span={2}></Col>
        <Col span={8}>
          <Card title="Нэвтэрсэн хэрэглэгчид">
            <Column xField={"date"} yField={"value"} data={loginUserChart} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
